<template>
  <QTable
    :columns="columns"
    row-key="id"
    :rows="reports"
    :rows-per-page-options="rowPerPage"
    @request="onRequest"
  >
    <QTr>
      <QTd />
      <QTd />
      <QTd />
      <QTd />
    </QTr>

    <template #body="props">
      <QTr :props="props">
        <QTd
          key="id"
          class="wrap-table-content vertical-top"
          :props="props"
        >
          {{ props.row.id }}
        </QTd>
        <QTd
          key="triggeredAt"
          class="wrap-table-content vertical-top"
          :props="props"
        >
          {{
            formatIntlDate(props.row.createdAt, {
              dateStyle: "medium",
              timeStyle: "short",
            })
          }}
        </QTd>
        <QTd
          key="sentAt"
          class="wrap-table-content vertical-top"
          :props="props"
        >
          {{
            formatIntlDate(props.row.updatedAt, {
              dateStyle: "medium",
              timeStyle: "short",
            })
          }}
        </QTd>
        <QTd
          key="actions"
          class="wrap-table-content"
          :props="props"
        >
          <QBtn
            color="primary"
            dense
            icon="open_in_new"
            title="View"
            @click="openReportUrl(props.row.htmlUrl)"
          />
        </QTd>
      </QTr>
    </template>
  </QTable>
</template>

<script>
import { formatIntlDate } from "shared/helpers/date";

export default {
  name: "ScheduledReportsTable",
  props: {
    reports: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:pagination", "request"],
  data() {
    return {
      columns: [
        {
          name: "id",
          required: true,
          label: "ID",
          align: "left",
          field: "id",
          style: "width: 15%",
          classes: "wrap-table-content",
        },
        {
          name: "triggeredAt",
          required: true,
          label: "Triggered At",
          align: "left top",
          field: "createdAt",
          style: "width: 30%",
          classes: "wrap-table-content",
        },
        {
          name: "sentAt",
          required: true,
          label: "Sent At",
          align: "left top",
          field: "updatedAt",
          style: "width: 30%",
          classes: "wrap-table-content",
        },
        {
          name: "actions",
          required: true,
          label: "View",
          align: "right top",
          style: "width: 25%",
          classes: "wrap-table-content",
        },
      ],
      rowPerPage: [10, 20, 100],
    };
  },
  methods: {
    formatIntlDate,
    openReportUrl(url) {
      window.open(url, "_blank");
    },
    onRequest({ pagination }) {
      this.$emit("update:pagination", pagination);
      this.$emit("request");
    },
  },
};
</script>
